import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ONBOARDING_ROUTES = ['/onboarding', '/onboarding/success'];
const PRODUCT_SELECTOR_ROUTE = '/select-product';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-emerald-500 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Allow product selector and settings pages through
  if (location.pathname === PRODUCT_SELECTOR_ROUTE || location.pathname.startsWith('/settings/account')) {
    return children;
  }

  // If user hasn't completed onboarding and isn't already on an onboarding route, redirect
  const isOnboardingRoute = ONBOARDING_ROUTES.some(r => location.pathname.startsWith(r));
  if (!isOnboardingRoute && user && user.onboarding_complete === false) {
    // Only redirect to onboarding for agent9 product routes
    const isVoicedeskRoute = location.pathname.startsWith('/voicedesk');
    if (!isVoicedeskRoute) {
      return <Navigate to="/onboarding" replace />;
    }
  }

  return children;
}
